import React from 'react';
import AuthContext from 'providers/auth';
import { withTranslation } from 'react-i18next';
import { FiSlash } from 'react-icons/fi';

const withAuthorizer = (WrappedComponent, resources = []) => {
  class Container extends React.Component {
    static contextType = AuthContext;

    render() {
      const { t } = this.props;

      if (!this.context.isAuthorized(resources)) {
        return (
          <div className="container text-center">
            <div>
              <FiSlash size={100} color="#ccc" />
            </div>
            <div className="mt-3">{t('authorizer.no_permission')}</div>
          </div>
        );
      }

      return <WrappedComponent {...this.props} />;
    }
  }

  return withTranslation()(Container);
};

export default withAuthorizer;
